import { createStore } from 'redux'
import persistedReducer from 'redux/reducers'

const Store = createStore(persistedReducer)
export default Store
